import React from 'react';
import useFadeIn from './useFadeIn';

const cards = [
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 8l1.5 3.5L17 12l-3.5 1.5L12 17l-1.5-3.5L7 12l3.5-1.5z" />
      </svg>
    ),
    title: 'Elegancki wygląd',
    desc: 'Imponująca sylwetka FX35 robi wrażenie na każdym i pięknie prezentuje się w każdym otoczeniu.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
    title: 'Komfortowe wnętrze',
    desc: 'Jasna skórzana tapicerka, klimatyzacja i cisza kabiny — czysty luksus na Wasz wyjątkowy dzień.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    ),
    title: 'Niezawodność',
    desc: 'Regularnie serwisowany pojazd, który nigdy nie zawodzi. Twoja ceremonia jest zbyt ważna na kompromisy.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <polyline points="21 15 16 10 5 21" />
      </svg>
    ),
    title: 'Idealny do zdjęć',
    desc: 'Dynamiczna linia nadwozia i efektowne felgi sprawiają, że każde zdjęcie wygląda jak z okładki magazynu.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 00-3-3.87" />
        <path d="M16 3.13a4 4 0 010 7.75" />
      </svg>
    ),
    title: 'Profesjonalna obsługa',
    desc: 'Indywidualne podejście do każdego klienta, elastyczne warunki najmu i pełna transparentność.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
      </svg>
    ),
    title: 'Wyjątkowe wspomnienia',
    desc: 'Każdy szczegół ma znaczenie. Zadbamy o to, aby Wasza wspólna jazda była początkiem pięknej historii.',
  },
];

export default function WhyUs() {
  const ref = useFadeIn();

  return (
    <section
      style={{
        padding: '120px 24px',
        background: 'linear-gradient(180deg, #0a1628 0%, #050a1a 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Grid background pattern */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `
            linear-gradient(rgba(59,130,246,0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(59,130,246,0.03) 1px, transparent 1px)
          `,
          backgroundSize: '60px 60px',
          pointerEvents: 'none',
        }}
      />

      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          width: 400,
          height: 400,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(59,130,246,0.08) 0%, transparent 70%)',
          right: -100,
          top: '50%',
          transform: 'translateY(-50%)',
          pointerEvents: 'none',
        }}
      />

      <div style={{ maxWidth: 1280, margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div ref={ref} className="fade-in-section" style={{ textAlign: 'center', marginBottom: 72 }}>
          <p className="section-label" style={{ marginBottom: 16 }}>Dlaczego warto</p>
          <h2 className="section-title">
            Sześć powodów,{' '}
            <span
              style={{
                fontStyle: 'italic',
                background: 'linear-gradient(135deg, #3b82f6, #60a5fa)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              dla których nas wybierają
            </span>
          </h2>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: 20,
          }}
        >
          {cards.map((card, i) => (
            <WhyCard key={card.title} {...card} delay={i * 80} />
          ))}
        </div>
      </div>
    </section>
  );
}

function WhyCard({ icon, title, desc, delay }) {
  const ref = useFadeIn();

  return (
    <div
      ref={ref}
      className="fade-in-section glass-card-light"
      style={{
        padding: '32px 28px',
        transition: 'all 0.35s ease',
        cursor: 'default',
        transitionDelay: `${delay}ms`,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'rgba(59,130,246,0.06)';
        e.currentTarget.style.borderColor = 'rgba(59,130,246,0.3)';
        e.currentTarget.style.transform = 'translateY(-6px)';
        e.currentTarget.style.boxShadow = '0 24px 60px rgba(0,0,0,0.4), 0 0 40px rgba(59,130,246,0.08)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'rgba(255,255,255,0.03)';
        e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: 14,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(59,130,246,0.08)',
          border: '1px solid rgba(59,130,246,0.2)',
          color: '#3b82f6',
          marginBottom: 20,
        }}
      >
        {icon}
      </div>
      <h3 style={{ fontSize: 16, fontWeight: 600, color: '#f4f5f7', marginBottom: 10, letterSpacing: '0.01em' }}>
        {title}
      </h3>
      <p style={{ fontSize: 13.5, color: 'rgba(244,245,247,0.5)', lineHeight: 1.7 }}>{desc}</p>
    </div>
  );
}
